module.exports = __webpack_public_path__ + "img/kt-zrk.6fed96a9.png";